import socket from "./socket";

const refreshDriverApp = (driverId) => {
  if (driverId) {
    socket.emit("driver:refreshDriverApp", { driverId });
  }
};

export default refreshDriverApp;
